<script setup>

const props = defineProps({
  pricingCards: Array,
  popular: Number,
  fields: Object,
  mobile: {
    type: Boolean,
    default: false
  }
})

const selectedPackage = ref(props.popular)
const handleSelection = (prodId) => {
  selectedPackage.value = prodId
}

const emit = defineEmits(['click']);

const handleClick = () => {
  emit('click', {
    prodId: selectedPackage.value
  })
}

</script>

<template>
  <div class="select-package">        
    <div class="text-center mt-2" v-html="fields.blockContent"></div>
    <div class="my-4 border-top">
      <div class="border-bottom border-left-0 border-top-0 border-right-0 bg-transparent w-100 py-3 px-4 row mx-0" :class="selectedPackage == pricingCard.productId ? 'selected' : ''" v-for="pricingCard in pricingCards" :key="pricingCard.productId">
        <div class="col-8">
          <div class="text-start form-check">
            <input class="form-check-input me-3" :class="pricingCards.length == 1 ? 'd-none' : ''" type="radio" :name="mobile ? 'mobile-radio' : 'radio'" :checked="pricingCard.productId == selectedPackage" :id="mobile ? `mobile-${pricingCard.productId}` : pricingCard.productId" @click="handleSelection(pricingCard.productId)">
            <label class="form-check-label mb-0" :for="mobile ? `mobile-${pricingCard.productId}` : pricingCard.productId">
              <div v-if="pricingCard.label === 'default'">
                <span class="fw-bold lessons">{{ pricingCard.quantity }} Lesson<span v-if="pricingCard.quantity > 1">s</span></span> <span v-if="fields.enableSubscription" class="lessons-month fw-bold">/ Month</span>
              </div>
              <div v-else>
                <span class="fw-bold lessons">{{ pricingCard.label }}</span> 
              </div>
            </label>
          </div>
          <div class="badges text-start ms-6">
            <span class="badge bg-light text-uppercase me-1 p-1" v-if="fields.enableSubscription && pricingCard.subscriptionSavePercentage > 0">SAVE {{ pricingCard.subscriptionSavePercentage }}%</span>
            <span class="badge bg-light text-uppercase me-1 p-1" v-if="!fields.enableSubscription && pricingCard.nonSubscriptionSavePercentage > 0">SAVE {{ pricingCard.nonSubscriptionSavePercentage }}%</span>
            <span class="badge bg-popular text-uppercase p-1" v-if="pricingCard.isMostPopular">MOST POPULAR</span>
          </div>
        </div>
        <div class="col-4">
          <span class="fw-bold unit-price">${{ fields.enableSubscription ? pricingCard.subscriptionUnitPrice : pricingCard.unitPrice }}</span><span class="currency">&nbsp;/Lesson</span>
        </div>
      </div>
    </div>
    <div class="text-center">
      <button :class="`btn btn-primary`" @click="handleClick">{{ fields.buttonText }}</button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.select-package {
  .form-check input.form-check-input[type=radio] ~ .form-check-label::before {
    top: 0.3rem;
  }
  
  .selected {
    border: solid 2px #9ac92f !important;
    border-radius: 15px;   
  }

  .form-check-label {
    font-size: 18px;
    color: #141414;
    font-stretch: normal;
  }
  .lessons-month {
    font-size: 14px;
  }  
  .unit-price {
    font-size: 18px;
    color: #333;
  }
  .currency {
    font-size: 12px;
    font-weight: bold;
  }
}

</style>